export interface PermissionsStateModel {
  initialState: boolean;
  permissions: string[];
  locations: string[];
  species: string[];
}

export const permissionsInitialState: PermissionsStateModel = {
  initialState: true,
  permissions: [],
  locations: [],
  species: []
};
